function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M341.333 85.333H51.2c-28.277 0-51.2 22.923-51.2 51.2v290.133c0 28.277 22.923 51.2 51.2 51.2h290.133c28.277 0 51.2-22.923 51.2-51.2V136.533c0-28.277-22.923-51.2-51.2-51.2z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M426.667 0h-307.2c-28.124-.001-50.984 22.684-51.2 50.807v.393h273.067c47.105.056 85.277 38.228 85.333 85.333V409.6h.393c28.124-.216 50.808-23.076 50.807-51.2V51.2c0-28.277-22.923-51.2-51.2-51.2z"
});

function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 477.867 477.867"
  }, props), _ref, _ref2);
}

export default SvgCopy;